import { Injectable } from '@angular/core';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { MessagesOrder } from 'src/sb-tools/typescript/enums/messages-order.enum';

@Injectable({
    providedIn: 'root',
})
export class ReplySortingService {
    public replySortBy = MessagesOrder.creationTimeAsc;

    private readonly socialMediaSortingTypeKey = 'socialMediaSortingType';
    private readonly formEmailApiSortingTypeKey = 'formEmailApiSortingType';

    constructor(
        private windowRef: WindowRef,
        private commonDataService: CommonDataService,
    ) {}

    public changeMessageOrder(isSocialMediaTicket: boolean) {
        if (this.replySortBy === MessagesOrder.creationTimeAsc) {
            this.replySortBy = MessagesOrder.creationTimeDesc;
        } else {
            this.replySortBy = MessagesOrder.creationTimeAsc;
        }
        this.saveReplyListSortingTypeInLocalStorage(this.replySortBy, isSocialMediaTicket);
    }

    public setReplyListSortingType(isSocialMediaTicket: boolean, isFormEmailApi: boolean) {
        const replySortingType = isSocialMediaTicket ? this.socialMediaSortingTypeKey : this.formEmailApiSortingTypeKey;

        const currentReplyListSortType: any = this.windowRef.nativeWindow.localStorage.getItem(replySortingType);

        if (currentReplyListSortType) {
            this.replySortBy = +currentReplyListSortType;
        } else if (isFormEmailApi && this.commonDataService.customerSettings.formEmailApiTicketRepliesOrder) {
            this.replySortBy = this.commonDataService.customerSettings.formEmailApiTicketRepliesOrder;
        }
    }

    private saveReplyListSortingTypeInLocalStorage(type, isSocialMediaTicket: boolean) {
        const replySortingType = isSocialMediaTicket ? this.socialMediaSortingTypeKey : this.formEmailApiSortingTypeKey;

        this.windowRef.nativeWindow.localStorage.setItem(replySortingType, type);
    }
}
